import { initRecipeList } from './list.js';

export { initRecipeList };

/**
 * Global initialization function
 */
export function initRecipes() {
	initRecipeList();
}
